import Server from './Server.model'
import Collection from '@/core/classes/Collection'

export default class Servers extends Collection {
  /**
   * Servers collection model
   *
   * @returns {Server}
   */
  model () {
    return Server
  }
}
